module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Chapters"
  }, [_c('span', [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph"
  }, [_vm._v("W"), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("hy the dinner date remained popular was a mystery to me. Most of the foods I preferred were difficult, if not impossible, to eat while projecting an aura of ")]), _c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("savoir-faire")]), _c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v(" at the same time. It was even worse when the female half of the date was so obviously out of my league. Fortunately, I was starving and my survival instinct vetoed any desire to impress my lawyer.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Duchess had suggested a place called the Petroleum Club, but I stood firm. I didn’t want to run up the tab any higher than I had to until I actually met her mystery employer. She had assured me a few thousand here or there wouldn’t faze him. I then played my trump card and said that after only two candy bars and bean paste in the last day, I didn’t think I could wait for a kitchen to prepare anything. Consequently, Duchess was the most elegantly dressed woman to ever sit in a McDonald’s booth.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“So when do I get to meet this boss of yours?” I asked between monster-sized bites.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She slurped from her strawberry milk shake. “Tomorrow morning. He’s flying in from Boston.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I laughed. “You’ve never been awkward a day in your life, have you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She glanced around nervously, as if the décor might attack her. “What? Is there…?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No, I mean you looked mortified when your straw made that noise. Have you ever even eaten fast food before?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Is it that obvious?” She shook her head and returned my laughter in kind. “I haven’t giggled like this in ages. You…I can’t predict you.” She slurped loudly, this time on purpose. “So, client-to-lawyer…did you kill any of them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Are you sure that’s a burger-and-fries type of question?” I glanced around to make sure no one else was listening. “And how many is 'them'? The FBI wasn’t particularly specific as to how many bodies I was supposed to have racked up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Six in the last month. All frozen, all mutilated. The police are getting desperate. Be glad I showed up or you’d still be stuck in there, sixth body or no sixth body. And you didn’t answer me. Did you kill any of them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No.” I shook my head.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“But you’ve killed someone before?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“No…I don’t know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Duchess winced as if she had an air horn go off next to her ear. I put my hand on hers. “Are you okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“That’s the second time something like that has happened. Let me try something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“What are you up to?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Just keep talking to her and stealing glances at her chest. I’ll handle the rest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Duchess…are you all right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She shook her head, looking very far from all right. She stole a swig of my Dr. Pepper. “Headache, I think, nothing too...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“GET OUT OF MY HEAD!”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She stopped in mid-sentence, her cheeks paling till they were the same tint as her hair. “All right, all right, I’ll behave,” she said weakly.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I nibbled my fries contemplatively. “You’re a telepath.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She nodded. “I barely even think about it anymore. Most people practically broadcast what they’re thinking. You…your defenses are impressive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I tried my shielding spell again, adding a helmet-shaped bubble covering my head. “Be careful when delving into the affairs of wizards for they are subtle and quick to steal your French fries. I may be misquoting.” I waited another second. “Is that better?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“I’m out, Girl Scout's honor. I can shut it down when I have to.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Murder, telepathy, and handcuffs. Definitely not the usual first dinner conversations. Most people would have run away screaming long ago.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("She snaked one golden strand of crisp potato between her luscious lips. “I’m not most people. Unseelie fey blood on my mom’s side.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Now it was my turn to look shocked. “Seriously?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Yeah, what about you? You’re clearly not human.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("I didn’t know how to answer. “As far as I know, yeah, I am. I have been studying magic ever since...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“Totally human, absolutely. Nothing to see here, move along.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("When I didn’t finish, she picked up where I left off. “Since when? I’ve met a few wizards and most of them are as easy to read as anyone else. Fakers and shakers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Since…you asked me if I ever killed someone. I haven’t. At least I don’t think so. I had this fiancée in college, Sarai. I loved her like crazy. She worked in a bookstore off campus. I must have bought a hundred extra books just as an excuse to see her. It took a while, but she gave in. We had a year together. One wonderful year…and then she was gone. She had spent the night in my apartment. We stayed up late reading spooky stories and munching popcorn. When morning came, she had simply disappeared. I…it changed everything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Duchess rubbed her hand on top of mine. “Let me guess. You spent all your time looking for her instead of going to class. You saw her everywhere, but it was never really her. Losing a love sucks, believe me, I know. But you didn’t kill her. And how did it get you into magic?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Maybe I did kill her. I have trouble remembering that night. And…the door was still chain-locked in the morning. Either she jumped out of a fourth-floor window, walked through a wall, or she never left the apartment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia__And__Italic"
  }, [_vm._v("“You ate her. Every last drop.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Duchess leaned back and closed her eyes. She tightened her face in an effort of concentration. “I believe you, Colin. I’m going to tell him that you didn’t kill any of his employees. I’m also going to tell him to hire you. If he offers you a job, any job, I suggest you take it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("“Is that why he sprung me out of jail? A job offer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }, [_c('span', {
    staticClass: "C_Current__And__Georgia"
  }, [_vm._v("Her smile was melancholy. “No. He wanted you free so he could torture and kill you himself. He’s not happy that someone is picking off his employees. And when he’s not happy...” Duchess shuddered all over.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-369c3588","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0016.vue
// module id = 108
// module chunks = 0